<app-signup-modal-form></app-signup-modal-form>

<div class="footer-link">
  Have an account?
  <div (click)="openSignIn()" class="link">Sign in</div>
</div>
